import { SideTabDescriptor, SideTabSection } from './types';

export const flattenTabs = (sections: SideTabSection[]): SideTabDescriptor[] =>
  sections.flatMap((section) => section.tabs);

/**
 * Derives both lookup directions from one source, so the `?tab=` param map and
 * the panel-value map cannot drift apart as tabs are added.
 */
interface TabMaps {
  tabs: SideTabDescriptor[];
  mapTabParamToValue: Record<string, string>;
  mapTabValueToTabParam: Record<string, string>;
}

export function buildTabMaps(sections: SideTabSection[], defaultValue: string): TabMaps {
  const tabs = flattenTabs(sections);

  return {
    tabs,
    mapTabParamToValue: {
      ...tabs.reduce<Record<string, string>>((acc, tab) => ({ ...acc, [tab.param]: tab.value }), {}),
      default: defaultValue,
    },
    mapTabValueToTabParam: tabs.reduce<Record<string, string>>((acc, tab) => ({ ...acc, [tab.value]: tab.param }), {}),
  };
}
